<script setup lang="ts">
import { useAccountStore } from '@caks/shared/store/store.account'
import { ref } from 'vue'

interface Props {
  color?: string
}

withDefaults(defineProps<Props>(), {
  color: 'white',
})

const store = useAccountStore()

const isShown = ref(false)

const show = () => {
  document.body.classList.add('_locked')
  isShown.value = true
}

const hide = () => {
  document.body.classList.remove('_locked')
  isShown.value = false
  store.changeAsideModalActive(false)
}

defineExpose({
  show,
  hide,
})
</script>

<template>
  <transition name="body">
    <div v-if="isShown" @click.self="hide" class="modal" id="aside-modal">
      <div class="modal__body">
        <slot />
      </div>
    </div>
  </transition>
</template>

<style scoped lang="scss">
@keyframes slide {
  0% {
    right: -460px;
  }
  100% {
    right: 0px;
  }
}
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: calc(0px + 100vh);
  z-index: 30000;
  background-color: rgba($color: #0d0802, $alpha: 0.4);
  display: flex;
  justify-content: flex-end;
  align-items: center;

  &__body {
    position: relative;
    right: 0px;
    padding: 32px;
    background-color: v-bind(color);
    border-radius: 20px 0px 0px 20px;
    height: 100%;
    max-width: 460px;
    animation: slide 0.3s ease;
  }
}

.body-enter-active,
.body-leave-active {
  transition: all 0.3s ease;
}

.body-enter-from,
.body-leave-to {
  opacity: 0;
}
</style>
